var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('RouterLink',_vm._b({staticClass:"navigation-top__logo"},'RouterLink',_vm.routerLinkProps,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }